export enum RetailDashboardTypes {
  TOP_10_PRODUCTS = "TOP_10_PRODUCTS",
  MOP = "MOP",
  TOP_5_PRODUCTS_AND_REST = "TOP_5_PRODUCTS_AND_REST",
  PRODUCTS_BY_SITE_IN_TIMESERIES = "PRODUCTS_BY_SITE_IN_TIMESERIES",
}
